import script from "./VerifyEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&setup=true&lang=js"

import "./VerifyEmail.vue?vue&type=style&index=0&id=30b010a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b010a8"]])

export default __exports__